// PWA custom event names
export const SIX_PWA_EVENT_UPDATE_AVAILABLE = 'six-pwa:update-available'
export const SIX_PWA_EVENT_OFFLINE_READY = 'six-pwa:offline-ready'
export const SIX_PWA_EVENT_INSTALL_AVAILABLE = 'six-pwa:install-available'
